import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","min-height":"100vh","flex-direction":"column"} }
const _hoisted_2 = {
  class: "navbar nav-color",
  role: "navigation",
  "aria-label": "main_navigation"
}
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-crosshairs" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, " Home", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "navbar-start" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Board Browser", -1)
const _hoisted_12 = {
  key: 0,
  class: "navbar-end"
}
const _hoisted_13 = { class: "navbar-item" }
const _hoisted_14 = { class: "has-text-light" }
const _hoisted_15 = { class: "navbar-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", { class: "has-text-light" }, "Logout", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "navbar-end"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", null, "Login", -1)
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<footer class=\"footer\" style=\"margin-top:auto;background:#155e98;\"><div class=\"container\"><div class=\"level\"><div class=\"level-left\"><div class=\"level-item\"><div><p class=\"title is-1 has-text-light\">Ekle Enterprise</p><p class=\"is-3 has-text-light\">enterprise.ekle@gmail.com</p></div></div></div><div class=\"level-right\"><div class=\"level-item\"><a href=\"https://discord.gg/pcWFzrAsQS\" class=\"has-text-light\"><span style=\"font-size:50px;\" class=\"icon\"><i class=\"fab fa-discord\"></i></span></a></div></div></div></div></footer>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "navbar-item has-text-light"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          role: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded)),
          class: _normalizeClass('nav-color navbar-burger has-text-light ' + (_ctx.expanded ? 'is-active' : '')),
          "aria-label": "menu",
          "aria-expanded": "false",
          "data-target": "main_navbar"
        }, _hoisted_9, 2)
      ]),
      _createElementVNode("div", {
        id: "main_navbar",
        class: _normalizeClass('navbar-menu primary-color  nav-color ' + (_ctx.expanded ? 'is-active' : ''))
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/boards",
            class: "navbar-item has-text-light nav-color is-info"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        (_ctx.$store.state.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("strong", _hoisted_14, "Hello, " + _toDisplayString(_ctx.$store.state.user.username), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "is-clickable",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
                }, _hoisted_17)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_router_link, {
                to: "/login",
                class: "navbar-item has-text-light nav-color",
                style: {}
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ]))
      ], 2)
    ]),
    _createVNode(_component_router_view),
    _hoisted_20
  ]))
}